import {Component, OnInit} from '@angular/core';
import {CpProvisionAgentBaseComponent} from '../base/cp-provision-agent-base.component';

/**
 * Side view of the ProvisionAgent OBC (`uiMode = 'side' | 'mini-side'`, PAT §L.2).
 *
 * Original: `bm-billing-area-side.component.ts`. The side panel is deliberately kept narrow:
 * master data and balances — including the underfunding hint that makes the payout brake
 * visible (U-03). The heavy lists (transactions, payouts, groups, coverage)
 * remain reserved for the full view, but are still reachable via `?sideNavItem=`.
 */
@Component({
    selector: 'cp-provision-agent-side',
    templateUrl: './cp-provision-agent-side.component.html',
    styleUrls: ['./cp-provision-agent-side.component.scss'],
    standalone: false
})
export class CpProvisionAgentSideComponent extends CpProvisionAgentBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
